import { render, staticRenderFns } from "./SyncCatalogCard.vue?vue&type=template&id=30005749&"
import script from "./SyncCatalogCard.vue?vue&type=script&lang=js&"
export * from "./SyncCatalogCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports